import { fetchWithFallback } from "../OrgUsageAnalytics/api";

/**
 * Running and past pilots, read live from HubSpot deals. The long timeout
 * covers the per-pilot notes search the backend runs to spot features.
 *
 * @param {"prod"|"dev"|"local"} env
 */
export const fetchPilots = (env) =>
  fetchWithFallback("/pilots", {}, { env, timeoutMs: 90000 });

/**
 * The FDE roster with each engineer's assigned client organizations.
 *
 * @param {"prod"|"dev"|"local"} env
 */
export const fetchFdeRoster = (env) => fetchWithFallback("/pilots/fdes", {}, { env });

/**
 * One client's people, loans, daily usage and recent Ask Addy questions.
 * `includeHubSpot` also resolves their HubSpot company, which costs live
 * HubSpot calls, so only ask for it when there is no other way to link them.
 *
 * @param {string} organizationId
 * @param {"prod"|"dev"|"local"} env
 * @param {{ includeHubSpot?: boolean, days?: number }} [options]
 */
export const fetchClientOverview = (organizationId, env, { includeHubSpot = false, days = 14 } = {}) =>
  fetchWithFallback(
    `/pilots/clients/${encodeURIComponent(organizationId)}/overview`,
    { days: String(days), includeHubSpot: includeHubSpot ? "true" : "" },
    { env, timeoutMs: 90000 },
  );

/**
 * What Addy actually spent on one client's loans over the last `days` days:
 * LLM cost, ExtendAI parsing cost and the real cost per loan.
 *
 * @param {string} organizationId
 * @param {"prod"|"dev"|"local"} env
 * @param {{ days?: number }} [options]
 */
export const fetchClientCosts = (organizationId, env, { days = 21 } = {}) =>
  fetchWithFallback(
    `/pilots/clients/${encodeURIComponent(organizationId)}/costs`,
    { days: String(days) },
    { env, timeoutMs: 60000 },
  );
